<template>
  <div>
    <v-select
      v-model="departmentValue"
      :disabled="!!actionValue"
      :items="departmentOptions"
      :loading="loading"
      :placeholder="'Выберите отдел'"
      dense
    />
    <v-list>
      <v-list-item
        v-for="activeAction in activeActions"
        v-bind:key="activeAction._id"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              @click="
                () =>
                  handleActionEnd({
                    startEventId: activeAction._id,
                    action: activeAction.action,
                  })
              "
              :disabled="loading"
              color="yellow darken-3"
              small
            >
              {{ getActionLabel(activeAction.action) }}
              <v-icon right dark>mdi-stop</v-icon>
            </v-btn>
          </template>
          <span>
            {{ getTooltipContent(activeAction) }}
          </span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-radio-group
      v-if="departmentValue === REGISTER"
      v-model="tagValue"
      :disabled="!!actionValue"
      class="mt-0"
      row
    >
      <v-radio
        v-for="actionTagOption in actionTagOptions"
        v-bind:key="actionTagOption.value"
        :label="actionTagOption.text"
        :value="actionTagOption.value"
      />
    </v-radio-group>
    <v-autocomplete
      v-model="actionValue"
      :items="actionOptions"
      :loading="loading"
      :placeholder="'Выберите действие'"
      clearable
      dense
    />
    <v-btn
      v-if="actionValue"
      @click="handleActionStart"
      :disabled="loading"
      small
    >
      {{ getActionLabel(actionValue) }}
      <v-icon right dark>mdi-play</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  CHAT_ACTIONS_MAP,
  CHAT_ACTION_TAG,
  CHAT_ACTION_TAGS,
  REGISTER_CHAT_ACTION,
} from '@/models/actions';
import { DEPARTMENT, DEPARTMENTS } from '@/models/departments';

const { REGISTER, FINANCES } = DEPARTMENT;
const ENABLED_DEPARTMENT_IDS = [REGISTER, FINANCES];

const { LETBE, LITLEO } = CHAT_ACTION_TAG;

const LITLEO_REGISTER_ACTION_IDS = [
  REGISTER_CHAT_ACTION.FREE_NOW_REGISTRATION,
  REGISTER_CHAT_ACTION.BOLT_REGISTRATION,
  REGISTER_CHAT_ACTION.UBER_INVITE,
  REGISTER_CHAT_ACTION.ADD_VEHICLE,
  REGISTER_CHAT_ACTION.CHECK_SUPPORT,
  REGISTER_CHAT_ACTION.BOLT_ASSIGN_CAR,
];

export default {
  name: 'ActionsSection',

  data() {
    return {
      REGISTER,
      actionTagOptions: CHAT_ACTION_TAGS,
      tagValue: LETBE,

      departmentValue: REGISTER,
      departmentOptions: DEPARTMENTS.filter(({ id }) =>
        ENABLED_DEPARTMENT_IDS.includes(id)
      ).map(({ id, name }) => ({ text: name, value: id })),

      loading: false,
      actionValue: null,
    };
  },

  computed: {
    ...mapGetters('support', {
      getSupportByAzureId: 'getSupportByAzureId',
    }),

    currentChat() {
      return this.$store.getters['chat/currentChat'];
    },

    currentSupport() {
      return this.$store.getters['support/currentSupport'];
    },

    actionOptions() {
      if (this.departmentValue === REGISTER && this.tagValue === LITLEO) {
        return CHAT_ACTIONS_MAP[this.departmentValue].filter(
          ({ value }) =>
            LITLEO_REGISTER_ACTION_IDS.includes(value) &&
            !this.activeActions.find(({ action }) => value === action)
        );
      }

      return CHAT_ACTIONS_MAP[this.departmentValue].filter(
        ({ value }) =>
          !this.activeActions.find(({ action }) => value === action)
      );
    },

    activeActions() {
      const { activeActions } = this.currentChat;

      if (!activeActions) return [];

      return activeActions.filter(
        ({ department }) => department === this.departmentValue
      );
    },
  },

  methods: {
    getActionLabel(action) {
      const actionLabel = CHAT_ACTIONS_MAP[this.departmentValue].find(
        ({ value }) => value === action
      )?.text;

      return actionLabel || action;
    },

    getTooltipContent(activeAction) {
      const { supportId, tags } = activeAction;
      const { nickname } = this.getSupportByAzureId(supportId);

      const tagsAsString = tags?.join(', ') || '';
      return [nickname, tagsAsString].join(' ');
    },

    async handleActionStart() {
      this.loading = true;

      const eventData = {
        action: this.actionValue,
        chatId: this.currentChat.chatId,
        department: this.departmentValue,
        ...(this.departmentValue === REGISTER ? { tags: [this.tagValue] } : {}),
      };

      try {
        await this.$store.dispatch(
          'chat/record_action_start',
          { eventData },
          { root: true }
        );

        this.actionValue = null;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async handleActionEnd({ startEventId, action }) {
      this.loading = true;

      const eventData = {
        action,
        chatId: this.currentChat.chatId,
        department: this.departmentValue,
      };

      try {
        await this.$store.dispatch(
          'chat/record_action_end',
          { eventData, startEventId },
          { root: true }
        );
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
